import * as eventTypes from "./eventTypes";
import * as actionTypes from "./actionTypes";
import api from "./api";
import { sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function computeFacilityNextStatesList(documentId, siteId) {
  return async (dispatch, getState) => {
    const nextStates = getState().facilities.facilityNextStates[documentId];

    let shouldCallApi = !nextStates || (!nextStates.loaded && !nextStates.loading);
    if (!shouldCallApi) return;

    try {
      dispatch({ type: actionTypes.COMPUTE_FACILITY_NEXT_STATES_STARTED, key: documentId });

      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.computeFacilityNextStatesList(documentId, siteId),
          "ComputeFacilityNextStatesListInProgress",
          [eventTypes.FACILITY_NEXT_STATES_LIST_COMPUTED],
          false
        )
      );

      if (event.ok) {
        dispatch({
          type: actionTypes.COMPUTE_FACILITY_NEXT_STATES_SUCCESS,
          payload: event.eventBody.nextStates,
          key: documentId
        });
      }
    } catch (error) {
      dispatch({ type: actionTypes.COMPUTE_FACILITY_NEXT_STATES_FAILED, key: documentId, error });
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateFacilityState(documentId, siteId, stateId, callback = () => {}) {
  return async dispatch => {
    try {
      const event = await dispatch(
        sendHttpCommandAndWaitForEvent(
          api.updateFacilityState(documentId, siteId, stateId),
          "UpdateFacilityStateInProgress",
          [eventTypes.FACILITY_STATE_UPDATED]
        )
      );
      if (event.ok) 
        callback();
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
